/**
 * Taxa mensal ↔ taxa anual, do lado do cliente.
 *
 * O schema guarda SEMPRE a taxa mensal em percentual. Mas ninguém anuncia CDB
 * "a 0,4868% ao mês" — anuncia "6% ao ano". Mostrar as duas lado a lado é o
 * que faz ela reconhecer o que cadastrou.
 *
 * Juros compostos, não divisão por 12. O espelho disto no backend é
 * `services/investmentProjection.ts`, que é quem projeta de verdade; aqui é só
 * exibição e o formulário de edição.
 */

import { formatPct } from './format';

export const annualToMonthlyRate = (annualPercent: number): number =>
  (Math.pow(1 + annualPercent / 100, 1 / 12) - 1) * 100;

export const monthlyToAnnualRate = (monthlyPercent: number): number =>
  (Math.pow(1 + monthlyPercent / 100, 12) - 1) * 100;

/** Taxa: duas casas de piso, quatro de teto — ver `formatPct`. */
export const fmtRate = (r: number, casas = 2): string => formatPct(r, casas, 4);

/** "0,90% ao mês · ≈ 11,35% ao ano" — as duas leituras da mesma taxa. */
export const describeRate = (monthlyPercent: number): string =>
  `${fmtRate(monthlyPercent)} ao mês · ≈ ${fmtRate(monthlyToAnnualRate(monthlyPercent))} ao ano`;
